import {useEffect} from 'react'

import {getEvents} from '../../../../../containers/BuildsFetcher'
import {useBuildTypeData} from '../../../../../hooks/useEntity'
import type {BuildId} from '../../../../../types'
import {subscribeOnBuildTypeEvents} from '../../../../../utils/subscriber'

export const useBuildParametersSubscription = (buildId: BuildId, refetch: () => void) => {
  const internalId = useBuildTypeData({buildId}, buildType => buildType?.internalId)
  useEffect(
    () =>
      internalId != null
        ? subscribeOnBuildTypeEvents(internalId, getEvents(true, true), refetch)
        : undefined,
    [internalId, refetch],
  )
}
